import { Injectable } from "@angular/core";
import { Step } from "./step";

import {
    PATH_STEP_1,
    PATH_STEP_3,
} from "../../app-routing.constants";

@Injectable({
    providedIn: "root",
})
export class StepsService {
    private _steps = [
        new Step(1, `/${PATH_STEP_1}`, "Basis"),
        new Step(3, `/${PATH_STEP_3}`, "Gegevens"),
    ];

    constructor() {
        //
    }

    public get steps() {
        return this._steps;
    }
}
